import axios from 'axios';
import API from '../config/API';

export const reportsService = {
    getReasons,
    getReportedUsers,
    getReportedDishes,
    getAddress,
    acceptReportedDish,
    rejectReportedDish,
}

const headersApplicationJson = {
    'Content-Type': 'application/json',
}
const headersMultipart = {
    "Content-type": "multipart/form-data",
}

function getReasons(params) {
    return axios.get(`${API.GET_REASONS}/${params}`);
}

function getAddress(params) {
    return axios.get(`${API.GET_ADDRESS}/${params}`);
}

function getReportedUsers(params) {
    return axios.get(`${API.GET_REPORTED_USERS}/${params}`);
}

function getReportedDishes(params) {
    return axios.get(`${API.GET_REPORTED_DISHES}/${params}`);
}

function acceptReportedDish(params) {
    return axios.post(API.ACCEPT_REPORTED_DISH, params, {
        headers: headersApplicationJson
    });
}

function rejectReportedDish(params) {
    return axios.post(API.REJECT_REPORTED_DISH, params, {
        headers: headersApplicationJson
    });
}

